<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/fondo-inmaterial.jpg"
  style="background-image: url('assets/img/fondo-catalogacion.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white;">Patrimonio Inmaterial del Centro Histórico del Cusco</h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="welcome-section mt-80 mt-md-60 mt-sm-40 mb-30" style="background-image: url('/assets/img/fondo-inmaterial5.png'); background-size: cover;
background-position: center;">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-8 m-auto text-center">
        <div class="section-title-wrap">
          <h2>Mapa interactivo del Patrimonio Inmaterial del Cusco</h2>
          <p class="mb-0" style="font-weight: 300;">El siguiente mapa se crea con el fin de identificar y revalorar la identidad
            cultural de la población cusqueña,
            actividades u oficios que desempeñan las personas con conviven dentro del Centro Histórico del Cusco. Estas
            actividades u oficios en muchos casos
            fueron pasados de generación en generación dando valor cultural a nuestro patrimonio inmaterial.<br>
            Es asi que con la catalogación del Patrimonio Inmaterial del Centro Histórico del Cusco se crea el programa
            <a href="https://www.youtube.com/channel/UCPaMQnyHK8r6LMt5Ml8nR2w" target="_blank"><strong> "HATUN
                QOSQO"</strong></a>.
          </p>
        </div>
      </div><!-- End Section title -->
    </div>

    <div class="row">
      <div class="col-lg-12 my-auto">
        <!-- Feature Product Left Side -->
        <div class="feature-product-left-wrap area-title mb-50 mb-sm-50 mb-md-50 ml-30 text-center">
          <h2 style="font-size:24px;">"HATUN QOSQO"</h2>
          <p class="m-0">Programa creado para preservar y salvaguardar la Identidad Cultural de la población cusqueña, difundiendo
            al público en general nuestras expresiones y manifestaciones originales, en imágenes de oficios, gastronomía,
            festividades cívicas y religiosas, mitos, oralidad, entre otros, como elementos culturales de valoración patrimonial
            inmaterial de los nueve sectores para la gestión y participación vecinal del Centro Histórico del Cusco.</p><a href="https://www.youtube.com/channel/UCPaMQnyHK8r6LMt5Ml8nR2w"
            class="btn btn-brand" target="_blank">Ver videos</a>
        </div>
      </div>
      <div class="col-lg-12 my-auto">
        <!-- Feature Product Left Side -->
        <div class="feature-product-left-wrap area-title mb-50 mb-sm-50 mb-md-50 ml-30 text-center">
          <h2 style="font-size:24px;">"EL CENTRO DEL CUSCO"</h2>
          <p class="m-0"><strong>Elaboración del Libro: “EL CENTRO DEL CUSCO”, Morada de historia y cultura viva.</strong>
            Texto cuya intención es transportar a los lectores de la mano por la ciudad, contando y mostrando su patrimonio cultural material e
            inmaterial más significativos, aquellos que se delinearon a lo largo de los años, que cuentan historias del pasado y del presente,
            que hacen así mismo, vivir el presente y reconociendo el pasado. Texto que busca introducir a quienes lo lean, en un espacio geográfico
            cultural, que siempre vibró y vivió intensamente cada etapa de su historia, y que fue marcada por su gente en las plazas, calles y edificios
            en la memoria colectiva. Compila datos de muchos especialistas apasionados por el Cusco, en páginas en un intento de mostrarlas en una narrativa unida y de fácil acceso.
          </p>
        </div>
        <iframe width="100%" height="460" src="https://www.youtube.com/embed/c7m_h_dNm3k" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </div>

  </div>
</section>
<section class="welcome-section mt-80 mt-md-60 mt-sm-40 mb-30" >
  <div class="container">
    <div class="row mt-60">
      <div class="col-lg-12">
        <h3 style="font-size: 24px; margin-bottom: 30px;" class="text-center">LEYENDA MAPA DE PATRIMONIO INMATERIAL</h3>
        <div class="row">
          <div class="col-md-12 text-center">
            <p><img src="assets/img/inma_icon_7.png" alt=""> Punto de ubicación de la catalogación del patrimonio inmaterial del Centro Histórico del Cusco.</p>
          </div>
        </div>
        <h4 style="font-size: 18px;margin-bottom: -30px;" class="mb-sm-20 mb-md-20 text-center">Leyenda Sectores de Gestión</h4>
        <div class="welcome-feature mt-sm-32 mt-md-36">
          <div class="row">
            <!-- Start Single Welcome Feature -->
            <div class="col-md-6">
              <div class="single-welcome-feature d-flex">
                <div class="feature-icon"><i class="fa fa-stop" style="color:#FDFEBC"></i></div>
                <div class="feature-info">
                  <p>SG-01 - Núcleo de Centro Histórico</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:#FDD282"></i></div>
                <div class="feature-info">
                  <p>SG-02 - San Cristóbal</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:#FE8584"></i></div>
                <div class="feature-info">
                  <p>SG-03 - Santo Domingo y San Agustín</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:#B6D79F"></i></div>
                <div class="feature-info">
                  <p>SG-04 - San Blas y Rimacpampa</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:#CF6B6A"></i></div>
                <div class="feature-info">
                  <p>SG-05 - Santa Ana</p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <!-- <h4 style="font-size: 18px; margin-bottom: -30px;" class="mb-sm-20 mb-md-20">Características de
                Catalogación</h4> -->
                <div class="single-welcome-feature d-flex" >
                  <div class="feature-icon"><i class="fa fa-stop" style="color:#0BC5FC"></i></div>
                  <div class="feature-info">
                    <p>SG-06 - San Pedro</p>
                  </div>
                </div>
                <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                  <div class="feature-icon"><i class="fa fa-stop" style="color:#D8A09F"></i></div>
                  <div class="feature-info">
                    <p>SG-07 - Pumacchupan, Av. Pardo y Tres Cruces</p>
                  </div>
                </div>
                <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                  <div class="feature-icon"><i class="fa fa-stop" style="color:#D3B8D2"></i></div>
                  <div class="feature-info">
                    <p>SG-08 - Almudena, Belén y Santiago </p>
                  </div>
                </div>
                <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                  <div class="feature-icon"><i class="fa fa-stop" style="color:#D0E5EA"></i></div>
                  <div class="feature-info">
                    <p>SG-09 - Totorapaccha, Mesa Redonda y Teteqaqa</p>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="showcase-description-area mt-40 mt-md-30 mt-sm-20 mb-30 mb-md-30 mb-sm-30 pb-20"
  style="background-color:#F4F4F4">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-8 m-auto text-center">
        <div class="section-title-wrap mt-50">
          <h2>BUSQUEDA DE INFORMACIÓN PATRIMONIO INMATERIAL</h2>
          <p class="mb-0" style="font-weight: 400;">
            El mapa de catalogación del patrimonio inmaterial del Centro Histórico del Cusco, nos brindará información
            sobre la identidad cultural de la población cusqueña, identificada en los 09 sectores de gestión, el mismo
            que se encontrará accesesible para el público en general.
            Para el uso del mapa interactivo adecuado, seguiremos los siguientes pasos:</p>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top:-100px;">
      <div class="col-12">
        <div class="showcase-description-content mt-lg-10 mt-xl-10">
          <div class="row">

            <div class="col-md-4">
              <div class="single-desc-item-wrap"><span class="desc-number mb-10">1°</span>
                <p>Debemos de ubicarnos en uno de los puntos de catalogación dentro de los 09 sectores
                  de gestión inmueble que se desea consultar, para ello usted podrá incrementar el zoom de navegación del mapa,
                  así como también deslizarlo a la izquierda y derecha.</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="single-desc-item-wrap"><span class="desc-number mb-10">2°</span>
                <p>Una vez que tenemos ubicado el punto que deseamos consultar, hacemos click sobre <img src="assets/img/inma_icon_7.png" alt="">,
                  el mismo que nos llevará a una ventana que habilitará el botón de <strong>"VER MÁS"</strong>, hacemos click en el para
                  visualizar la información.</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="single-desc-item-wrap"><span class="desc-number mb-10">3°</span>
                <p>Una vez en la información del patrimonio inmaterial catalogado, podremos observar la información recabada a partir de entrevistas
                  generadas en la catalogación, realizada en los 09 sectores del centro histórico del Cusco.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-mapbox-inmaterial></app-mapbox-inmaterial>
